var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransformationRugby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #47464b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.41px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 54.37,
    y1: 92,
    x2: 54.37,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 95.63,
    y1: 92,
    x2: 95.63,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.87,
    y: 75.8,
    width: 7.52,
    height: 16.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.61,
    y: 75.8,
    width: 7.52,
    height: 16.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 54.37,
    y1: 67.92,
    x2: 95.63,
    y2: 67.92
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.15,28.64h17.61v4.63h-5.91v14.12h-5.79v-14.12h-5.91v-4.63Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformationRugby);
export default __webpack_public_path__ + "static/media/Transformation_rugby.101d1bb6d10bc8693c8ef0f717a7eac8.svg";
export { ForwardRef as ReactComponent };